<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <DashboardAlert
      v-if="generals"
      :title="$t(generals.status)+' '+timestamp"
      :description="generals.status === 'rejected' ? generals.document.tickets[0].comment : generals.status === 'success' ? $t('generalDocument.success-msg') : $t('generalDocument.pending-new-msg')"
      :variant="generals.status === 'pending'? 'warning' : generals.status === 'success' ? 'success' : 'danger'"
      :btn-text="$t('go_to_dashboard')"
      :btn-to="'/'+this.$i18n.locale+'/dashboard'"
      :btn-target="'_self'"
    />

    <b-row class="mb-2">
      <b-col
        class=""
        xl="12"
        md="12"
        sm="12"
      >
        <b-card
          id="general_document"
          :title="$t('general')"
          class="h-100"
        >
          <GetDescription name="document-general-description" />
          <validation-observer ref="generalTab">
            <!-- form -->
            <b-form class="mt-2">
              <b-row>
                <b-col
                  xl="4"
                  sm="12"
                >
                  <b-form-group
                    :label="$t('id_type')"
                    label-for="ID Type"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('id_type')"
                      vid="ID Type"
                      rules="required"
                    >
                      <v-select
                        id="ID Type"
                        v-model="id_type"
                        item-value="id"
                        label="translation_identity"
                        name="ID Type"
                        autocomplete="off"
                        :placeholder="$t('id_type')"
                        :options="idTypes"
                        @input="changeLable"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col
                  xl="4"
                  sm="12"
                >
                  <b-form-group
                    :label="$t(lable)"
                    label-for="national-id"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(lable)"
                      vid="national-id"
                      :rules="id_type?(id_type.identity === 'identity_certificate' ? 'required' : id_type.identity === 'passport' ? 'required|passportValidate' : ''):''"
                    >
                      <b-form-input
                        v-model="NationalId"
                        :placeholder="$t(placeholder)"
                        name="id_number"
                        autocomplete="nope"
                        @keypress="getCitizenship === 'IR' ? onlyNumbers($event) : AlphaNumeric($event)"
                      />
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="id_type&&id_type.identity === 'identity_certificate'"
                  xl="4"
                  sm="12"
                >
                  <b-form-group
                    :label="$t('identity_certificate_number')"
                    label-for="identityCertificate"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(lable)"
                      vid="identityCertificate"
                      rules="required|numeric"
                    >
                      <b-form-input
                        v-model="identityCertificate"
                        :placeholder="$t('identity_certificate_number')"
                        name="identityCertificate"
                        autocomplete="nope"
                        @keypress="getCitizenship === 'IR' ? onlyNumbers($event) : AlphaNumeric($event)"
                      />
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="id_type&&id_type.identity !== 'identity_certificate'"
                  xl="4"
                  sm="12"
                >
                  <b-form-group
                    label-for="expiration-date"
                    :label="$t('document_general_expiration_date')"
                  >
                    <validation-provider
                      #default="{ errors }"
                      ref="expiration_date_ref"
                      name="expiration-date"
                      vid="expiration-date"
                      rules="required"
                    >
                      <date-picker
                        id="expiration-date"
                        v-model="expiration_date"
                        :color="getColor('primary')"
                        :locale="citizenship() === 'iran' ? lable === 'national-id' ? 'fa' : 'en' : 'en'"
                        type="date"
                        :placeholder="$t('document_general_expiration_date')"
                        :disabled="!id_type"
                        auto-submit
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-alert
                    v-if="citizenship() === 'iran' && lable === 'national-id'"
                    class="px-1 py-1"
                    :show="lable === 'national-id' && convertedExpiration"
                  >
                    <div :class="$store.state.appConfig.layout.skin === 'dark' && 'text-white'">
                      <span>{{ $t('exipiration_data_in_gregorian') }}</span>
                      <span> : </span>
                      <span dir="ltr">{{ convertedExpiration || '' }}</span>
                    </div>
                  </b-alert>
                </b-col>
                <b-col
                  xl="4"
                  sm="12"
                >
                  <!-- <b-alert
                    show
                    variant="danger"
                    class="p-1"
                  >
                    <span class="pre-line">
                      {{ $t('uploadImageFromGallery') }}
                    </span>
                  </b-alert> -->
                  <b-form-group
                    :label="$t('document_general_front_photo')"
                    label-for="file_front"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('document_general_front_photo')"
                      vid="file_front"
                      :rules="'image|required|size:' + MAX_IMAGE_UPLOAD_SIZE"
                    >
                      <div class="row">
                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <!-- file_front input -->
                          <b-form-file
                            id="file_front"
                            ref="file_front"
                            v-model="file_front"
                            :placeholder="$t('no_file_chosen')"
                            accept="image/png, image/jpg, image/jpeg"
                          />
                        </div>

                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="id_type&&id_type.identity === 'nationality_identification_card'"
                  xl="4"
                  sm="12"
                >
                  <!-- file_back input -->
                  <b-form-group
                    :label="$t('document_general_back_photo')"
                    vid="file_back"
                    label-for="file_back"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('document_general_back_photo')"
                      :rules="'image|required|size:' + MAX_IMAGE_UPLOAD_SIZE"
                    >
                      <div class="row">
                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <b-form-file
                            id="file_back"
                            ref="file_back"
                            v-model="file_back"
                            accept="image/png, image/jpg, image/jpeg"
                            :placeholder="$t('no_file_chosen')"
                          />
                        </div>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  xl="4"
                  sm="12"
                >
                  <!-- file_back input -->
                  <b-form-group
                    :label="$t('document_general_proof_photo')"
                    label-for="file_proof"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('document_general_proof_photo')"
                      :rules="'image|required|size:' + MAX_IMAGE_UPLOAD_SIZE"
                      vid="file_proof"
                    >
                      <div class="row">
                        <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                          <b-form-file
                            id="file_proof"
                            ref="file_proof"
                            v-model="file_proof"
                            accept="image/png, image/jpg, image/jpeg"
                            :placeholder="$t('no_file_chosen')"
                          />
                        </div>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  class="d-flex flex-column align-items-end"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mt-2 mr-1 "
                    :disabled="generals && generals.status == 'pending'"
                    pill
                    @click="submit"
                  >
                    <span v-if="!pending">{{ $t('save_changes') }}</span>
                    <b-spinner
                      v-else
                      small
                      type="grow"
                    />
                  </b-button>
                </b-col>
                <b-col>
                  <div
                    v-if="isPreparingFiles"
                    class="text-center"
                  >
                    <h5 class="mt-2">
                      {{ $t('preparingFiles') }}
                    </h5>
                    <b-spinner
                      variant="primary"
                      label="Spinning"
                    />
                  </div>
                  <div
                    v-if="uploadSize > 0"
                    class="text-center"
                  >
                    <h5 class="mt-2">
                      {{ $t('uploading') }}
                    </h5>
                    <b-progress
                      :value="currentUpload"
                      :max="uploadSize"
                      show-progress
                      animated
                      dir="ltr"
                      height="20px"
                    />
                  </div>
                  <DashboardAlert
                    v-if="generals && generals.status == 'pending'"
                    class="mt-1"
                    :description="$t('yourDocumentIsUnderReview')"
                    :variant="'primary'"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      </b-col>

      <b-col
        xl="12"
        md="12"
        sm="12"
      >
        <b-card class="h-100 w-100">
          <div class="d-flex justify-content-between align-items-center">
            <h4>{{ $t('how-to-selfi') }}</h4>
            <b-button
              v-if="isCryptoMode"
              variant="primary"
              pill
              style="margin-inline-start: auto;"
              class="my-2 "
              @click="commitmentTextModal = true"
            >
              {{ $t('commitment_text') }}
            </b-button>
          </div>
          <br>
          <div class="d-md-flex mt-1">
            <b-img
              fluid
              width="120"
              :src="require('@/assets/images/image/crypto3.png')"
            />
            <p class="align-self-center mt-1 mx-1">
              <span v-if="isCryptoMode">
                {{ $t('doucumnetGeneralPage.generalImage1Description') }}
              </span>
              <span v-else>
                {{ $t('doucumnetGeneralPageWithoutCommitment.generalImage1Description') }}
              </span>
            </p>
          </div>
          <br>
          <div
            class="d-md-flex"
          >
            <b-img
              fluid
              width="120"
              :src="require('@/assets/images/image/crypto2.png')"
            />
            <p
              :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
              class="align-self-center mt-1 mx-1"
            >
              <span v-if="isCryptoMode">
                {{ $t('doucumnetGeneralPage.generalImage2Description') }}
              </span>
              <span v-else>
                {{ $t('doucumnetGeneralPageWithoutCommitment.generalImage2Description') }}
              </span>
            </p>
          </div>
          <br>
          <div class="d-md-flex">
            <b-img
              fluid
              width="120"
              :src="require('@/assets/images/image/crypto4.png')"
            />
            <p class="align-self-center mt-1 mx-1">
              <span v-if="isCryptoMode">
                {{ $t('doucumnetGeneralPage.generalImage3Description') }}
              </span>
              <span v-else>
                {{ $t('doucumnetGeneralPageWithoutCommitment.generalImage3Description') }}
              </span>
            </p>

          </div>

        </b-card>

      </b-col>
    </b-row>

    <b-modal
      v-model="commitmentTextModal"
      :title="$t('commitment_text')"
      centered
      size="lg"
      hide-footer
    >
      <template>
        <h4 class="mt-1">
          {{ $t('commitment_modal_title') }}
        </h4>
        <!-- <b-card :show-footer="false">
          <b-card-body> -->
        <hr class="my-2">
        <p>{{ $t('commitment_modal_content',{brand_name:getBrandName()}) }}</p>
        <h6>{{ $t('firstName_lastName') }}</h6>
        <h6>{{ $t('date') }}</h6>
        <h6>{{ $t('signature') }}</h6>
        <!-- </b-card-body>
        </b-card> -->
      </template>
    </b-modal>

  </b-overlay>
</template>
<script>
import GetDescription from '@/views/theme2/components/getDescription.vue'
import General from '@/views/logics/documents/General'
import DashboardAlert from '../dashboard/dashboardAlert.vue'

export default {
  components: {
    GetDescription,
    DashboardAlert,
  },

  mixins: [General],
}
</script>
<style>
.right-position {
  float: right;
}

.left-position {
  float: left;
}
.pre-line{
  white-space: pre-line;
}
</style>
